// 键名与中文包完全一致，值为对应英文翻译
export default {
    common: {
      welcome: "Welcome to the system",
      login: "Login",
      logout: "Logout",
      language: "Language"
    },
    store: {
      name: "Store Name",
      address: "Store Address",
      phone: "Contact Phone"
    }
  };